<template>
  <div>
    <center-nav></center-nav>
    <slider-menu :menuData="menuData"></slider-menu>
  </div>
</template>

<script>
import centerNav from "../../../components/centerNav";
import sliderMenu from "@/components/SliderMenu";
import { mapGetters } from "vuex";
import douYin from "@/javaApi/douyin";
const DouYinModel = new douYin();
import mini from "@/api/mini";
const MiniModel = new mini();
export default {
  components: {
    sliderMenu, // 侧边栏
    centerNav, // 头部导航
  },
  data() {
    return {
      ksGroupOrderLogicShow: false,
      oldPathName: "kuaishouLiveOrderList",
    };
  },
  computed: {
    isSaasProxyUser: function () {
      return this.$store.getters.isSaasProxyUser;
    },
    isDyAppOwner: function () {
      return this.$store.getters.isDyAppOwner;
    },
    ...mapGetters(["isOpenKuaiShou"]),
    menuData() {
      return [
        {
          path: "/pc/kuaishou/help",
          icon: "icon-dy_refresh_home_n_1",
          title: "合作引导",
          hidden: this.isOpenKuaiShou,
          iconSize: "16px",
        },
        {
          path: "/pc/kuaishou/home/index",
          icon: "icon-dy_refresh_home_n_1",
          title: "数据概况",
          hidden: !this.isOpenKuaiShou,
          iconSize: "16px",
        },
        {
          path: "/pc/kuaishou/liveOrderList",
          icon: "icon-dy_refresh_fxzx_n_4",
          title: "订单列表",
          hidden: !this.isOpenKuaiShou,

          iconSize: "16px",
          children: [
            {
              path: "/pc/kuaishou/liveOrderList/index",
              title: "推广订单列表",
            },
            {
              path: "/pc/kuaishou/groupOrderList/index",
              title: "团购核销列表",
              hidden: !this.ksGroupOrderLogicShow,
            },
          ],
        },

        {
          path: "/pc/kuaishou/financialDetails/index",
          icon: "icon-dy_refresh_money_n_3",
          title: "分佣明细",
          hidden: !this.isOpenKuaiShou,
          iconSize: "16px",
        },
        {
          path: "/pc/kuaishou/distribution",
          icon: "icon-dy_refresh_fxzx_n_4",
          title: "分销中心",
          hidden: !this.isOpenKuaiShou,

          iconSize: "16px",
          children: [
            {
              path: "/pc/kuaishou/distribution/masterList",
              title: "达人列表",
            },
            {
              path: "/pc/kuaishou/distribution/settle",
              title: "达人结佣管理",
            },
            {
              path: '/pc/kuaishou/proxyList/index',
              title: '分销代理列表',
              hidden: !(this.$store.getters.isSaasProxyUser === 1 && this.$store.getters.isDyAppOwner === 1),
            },
            {
              path: '/pc/kuaishou/userData',
              title: "分销代理结佣管理",
              hidden: !(this.$store.getters.isSaasProxyUser === 1 && this.$store.getters.isDyAppOwner === 1),
            },
            
          ],
        },
      ];
    },
  },
  watch: {
    $route: {
      // 监听路由变化
      immediate: true,
      handler(val) {
        if (!val.params.go) {
          this.oldPathName = this.$route.name;

          this.getPermission();
        }
      },
    },
    isOpenKuaiShou: {
      // 是否有快手权限
      handler(val) {
        !val
          ? this.$router.push({
              name: "kuaishounHelp",
              params: {
                go: true,
              },
            })
          : this.$router.push({
              name: this.oldPathName,
              params: {
                go: true,
              },
            });
      },
    },
  },
  methods: {
    // 是否有团购券权限
    async getksGroupOrderLogicShow() {
      const res = await MiniModel.getConfigGet({ name: "ksGroupOrderLogicShow" });
      this.ksGroupOrderLogicShow = res.data.code === 200 && res.data.data === "1";
    },
    // 是否有快手路由权限
    async getPermission() {
      const res = await DouYinModel.getPermission({ miniType: 5 });
      if (res.data.code === 200) {
        console.log(res.data, "是否有快手路由权限");
        const status = res.data.data !== 0;
        this.$store.commit("nav/SET_ISOPEN_KUAISHOU", status);
        if (res.data.data === 0) {
          this.$router.push({
            name: "kuaishounHelp",
            params: {
              go: true,
            },
          });
        } else {
          this.$router.push({
            name: this.oldPathName,
            params: {
              go: true,
            },
          });
        }
        // 请求是否有快手权限
        this.getksGroupOrderLogicShow();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pc/kuaishou/index.vue